import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { errorMessage } from '../api/client';

export function ErrorAlert({
  error,
  title = 'No se pudo completar la operación',
}: {
  error: unknown;
  title?: string;
}) {
  if (!error) return null;
  return (
    <Alert color="red" icon={<IconAlertTriangle />} title={title} mb="md">
      {errorMessage(error)}
    </Alert>
  );
}
